import { ReviewsTypes } from '@frontend/api-reviews';
import { FacebookRating } from './facebook-rating';
import { GoogleRating } from './google-rating';

type Props = {
  siteName: ReviewsTypes.SiteName;
  rating?: number;
  recommendation?: ReviewsTypes.Recommendation;
};

export const ReviewRating = ({ siteName, rating, recommendation, ...rest }: Props) => {
  switch (siteName) {
    case ReviewsTypes.SiteName.Facebook:
      return <FacebookRating rating={rating} recommendation={recommendation} {...rest} />;
    case ReviewsTypes.SiteName.Google:
      return <GoogleRating rating={rating} {...rest} />;
    case ReviewsTypes.SiteName.Private:
    default:
      return null;
  }
};
